import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import usePrevious from 'lib/src/hooks/usePrevious';
import { deleteSuperAdminUser } from '@actions/superAdminUsers/deleteSuperAdminUser';
import {
    getSuperAdminUserIsPosting,
    getSuperAdminUserPostSuccess,
    getSuperAdminUsersPostError,
} from '@selectors/superAdminUsers';
import { useHistory } from 'react-router-dom';

export default function useDeleteSuperAdmin(userID: number): UseDeleteSuperAdminReturn {
    const dispatch = useDispatch();
    const history = useHistory();

    const deleteUser = useCallback(() => {
        dispatch(deleteSuperAdminUser(userID));
    }, [dispatch, userID]);

    const isPosting = useSelector(getSuperAdminUserIsPosting);
    const error = useSelector(getSuperAdminUsersPostError);
    const successs = useSelector(getSuperAdminUserPostSuccess);
    const prevSuccess = usePrevious(successs);

    useEffect(() => {
        if (!prevSuccess && successs) {
            history.replace('/superadmins');
        }
    }, [successs, prevSuccess, history]);

    return {
        deleteUser,
        isPosting,
        error,
    };
}

interface UseDeleteSuperAdminReturn {
    deleteUser: () => void;
    isPosting: boolean;
    error: string | null;
}
